<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <h5>Change Examination Schedule Start Date/Time</h5>
    <div class="container">
      <div class="form-group mt-2">
        <label for="startDate">New Start Date/Time*</label>
        <input id="startDate" type="datetime-local" class="form-control" [value]="changeDateTimeModel.startDateTime"
          (change)="onStartDateChange($event)" />
      </div>
      <div class="form-group mt-2">
        <label for="startDate">New End Date/Time(Leave Blank To auto-Adjust)</label>
        <input id="startDate" type="datetime-local" class="form-control" [value]="changeDateTimeModel.endDateTime"
          (change)="onEndDateChange($event)" />
      </div>

      <div class="row-cols-3 d-flex">
        <div class="col">
          <div class="form-group mt-2">
            <input id="pause" type="checkbox" class="form-check-input" [checked]="changeDateTimeModel.dateOnly"
              (change)="onDateOnlyChange($event)" />
            <label for="pause" class="form-check-label ml-2">Change Date Only</label>
          </div>
        </div>
        <div class="col">
          <div class="form-group mt-2">
            <input id="viaEmail" type="checkbox" class="form-check-input" [checked]="changeDateTimeModel.viaEmail"
              [(ngModel)]="changeDateTimeModel.viaEmail" name="viaEmail" />
            <label for="viaEmail" class="form-check-label ml-2">Send Email Notification</label>
          </div>
        </div>
        <div class="col">
          <div class="form-group mt-2">
            <input id="restartExam" type="checkbox" class="form-check-input"
              [(ngModel)]="changeDateTimeModel.restartExam" name="restartExam"
              [checked]="changeDateTimeModel.restartExam" />
            <label for="restartExam" class="form-check-label ml-2">Restart Exam</label>
          </div>
        </div>
      </div>
      <div *ngIf="changeDateTimeModel.viaEmail" class="mb-3 mr-0 mt-5 col-md-12">
        <div class="mb-3 mr-0 col-md-10">
          <label class="form-label">Subject</label>
          <input class="form-control" type="text" [(ngModel)]="changeDateTimeModel.emailSubject" name="subject" />
        </div>
        <div class="mb-2">
          <h5>Possible Placeholder Options</h5>
          <p>Use the following placeholders to customize your message. <span class="text-primary">Click on the
              placeholder to copy it</span></p>
          <ul class="flex-grid">
            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{candidate_fullname}', $event)">
              Candidate Fullname
            </span>
            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{candidate_exam_number}', $event)">
              Candidate Exam Number
            </span>
            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{candidate_firstname}', $event)">
              Candidate FirstName
            </span>
            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{candidate_lastname}', $event)">
              Candidate LastName
            </span>
            <span class="btn btn-outline-secondary placeholder-tag" (click)="copyPlaceholder('{exam_name}', $event)">
              Exam Name
            </span>
            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{exam_start_datetime}', $event)">
              Exam Start Datetime
            </span>

            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{exam_end_datetime}', $event)">
              Exam End Datetime
            </span>

            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{exam_duration}', $event)">
              Exam Duration
            </span>

            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{schedule_start_datetime}', $event)">
              Schedule Start Datetime
            </span>

            <span class="btn btn-outline-secondary placeholder-tag"
              (click)="copyPlaceholder('{schedule_end_datetime}', $event)">
              Schedule End Datetime
            </span>
          </ul>

          <!-- Toast -->
          <div *ngIf="toast.visible" class="copy-toast" [ngStyle]="{ top: toast.y + 'px', left: toast.x + 'px' }">
            Copied and inserted!
          </div>



        </div>
        <label class="form-label">Message</label>
        <quill-editor #editor [(ngModel)]="changeDateTimeModel.emailMessage" name="message"
          (onEditorCreated)="onEditorReady($event)">
        </quill-editor>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <button type="button" class="btn btn-primary btn-lg col-md-10" (click)="yesClicked()">Submit</button>
      </div>
    </div>

  </div>
</div>